import Vue from 'vue'
import Vuex from 'vuex'
// upInformation

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    locale: sessionStorage.getItem('locale') ? sessionStorage.getItem('locale') : 'zh',
    hasChecked: sessionStorage.getItem('hasChecked') ? sessionStorage.getItem('hasChecked') : false,
    access_token: sessionStorage.getItem('access_token') ? sessionStorage.getItem('access_token') : '',
    userData: sessionStorage.getItem('userData') ? JSON.parse(sessionStorage.getItem('userData')) : {},
    plantList: sessionStorage.getItem('plantList') ? JSON.parse(sessionStorage.getItem('plantList')) : [],
    authKey: sessionStorage.getItem('authKey') ? sessionStorage.getItem('authKey') : '',
    collapseMenuState: sessionStorage.getItem('collapse_menu_state') ? sessionStorage.getItem('collapse_menu_state') : 'closed'
  },
  mutations: {
    setLocale(state,data) {
      state.locale = data;
      sessionStorage.setItem("locale", data); 
    },
    setHasChecked(state,data) {
      state.hasChecked = data;
      sessionStorage.setItem("hasChecked", data); 
    },
    setAccessToken(state,data) {
      state.access_token = data;
      sessionStorage.setItem("access_token", data); 
    },
    removeAccessToken(state) {
      state.access_token = '';
      sessionStorage.removeItem("access_token"); 
    },
    setUser(state,data) {
      state.userData = data;
      sessionStorage.setItem("userData", JSON.stringify(data)); 
    },
    removeUser(state) {
      state.userData = {};
      sessionStorage.removeItem("userData"); 
    },
    logout(state) {
      state.access_token = '';
      state.userData = {};
      state.authKey = '';
      sessionStorage.removeItem("access_token"); 
      sessionStorage.removeItem("userData"); 
      sessionStorage.removeItem("authKey"); 
    },
    setPlantList(state, data) {
      state.plantList = data;
      sessionStorage.setItem("plantList", JSON.stringify(data)); 
    },
    setAuthKey(state, data) {
      state.authKey = data;
      sessionStorage.setItem("authKey", data); 
    },
    removeAuthKey(state) {
      state.authKey = '';
      sessionStorage.removeItem("authKey"); 
    },
    setCollapseMenuState(state, data) {
      state.collapseMenuState = data;
      sessionStorage.setItem("collapse_menu_state", data); 
    }
  },
  actions: {
  },
  modules: {
  }
})
